import script from "./GameDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameDashboard.vue?vue&type=script&setup=true&lang=js"

import "./GameDashboard.vue?vue&type=style&index=0&id=b58828a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b58828a0"]])

export default __exports__